import React, {useMemo, useState} from 'react'
import ReactScrollLink from '../General/ReactScollLink'
import Translation from '../General/Translation';
import getMovieTitle from '../functions/getMovieTitle';
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj';
import getTranslation from '../functions/getTranslation';
import getBackgroundStyles from '../functions/getBackgroundStyles';
import Length from '../MovieInformation/Length';
import getMovieLink from '../functions/getMovieLink';
import FskWrapper from '../MovieInformation/FskWrapper';
import getCinemasPerMovie from '../functions/getCinemasPerMovie';
import { MASTERMULTITOTAL } from '../constants/multiCinemaModes';
import CinemaIcon from './CinemaIcon';
import ItemPerformancesContainer from '../PosterFormatItem/ItemPerformancesContainer';
import useCinemaColorsAndIcons from '../hooks/useCinemaColorsAndIcons';
import getCinemaStyles from '../functions/getCinemaStyles';
import getBluePrices from '../functions/getBluePrices';
import getPosterAttributeSettings from '../functions/getPosterAttributeSettings';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';
import getAttributesDisplaySettings from '../functions/getAttributesDisplaySettings';
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer';

const  BackgroundFormatItemLink = ({children, moviesRoutesData, goToMoviepage, onClick, to, smooth, offset, translation, pk, className}) => {
    const linkUrl = moviesRoutesData ? getMovieLink(pk, moviesRoutesData, translation) : '#'
    if(goToMoviepage) {
        return <a className={className} href={linkUrl}>
            {children}
        </a>
    } else {
        return <ReactScrollLink className={className} onClick={onClick} to={to} smooth={smooth} offset={offset}>
            {children}
        </ReactScrollLink>
    }
}

const BackgroundFormatItem = ({
    itemID, 
    itemData, 
    translation, 
    scrollToPosition, 
    queryStringValues,
    isMobile=false, 
    goToMoviepage=false,
    onClickItem, 
    filterValue,
    filterType,
    dayFilters,
    hideInfo=false,
    moviesRoutesData,
    posterStyling,
    index = '', 
    overviewFilterIgnoreOnPerformances,
    cinemas,
    showPerformances, 
    stripeAppearance,
    onOpenPerformancePage=null, 
}) => {
       const [mouseOver, setMouseOver] = useState(false)
    if(!itemData) {
        return ''
    }

    const { title, images, technologyAttributes, performances, posterAttribute, fsk, trailerURL, length, pk } = itemData
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )
    
    const cinemaColorSettings = useCinemaColorsAndIcons()
    const {multitotalStyle, themeColors, multiCinemaMode} = cinemaColorSettings
    const relevantCinemas = multiCinemaMode === MASTERMULTITOTAL ? getCinemasPerMovie(performances) : []
    const {cinemaColor} = getCinemaStyles(cinemaColorSettings, relevantCinemas)
    const style = mouseOver && cinemaColor && multitotalStyle === "colored" && multiCinemaMode === MASTERMULTITOTAL ? {
        borderColor: cinemaColor
    } : {}

    const currentTitle = getMovieTitle(itemData)
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, filterType, filterValue, queryStringValues)
    const {noAttributesWithIconsToDisplay, noAttributesToDisplayWithSchnäppchen, noAttributesWithoutIconsToDisplay, technologyAttributesWithoutIcons, technologyAttributesWithIcons} = getAttributesDisplaySettings(technologyAttributes, performances, filterValue, filterType, queryStringValues, performanceFilterIsSet, translation)
    const borderClass = showPerformances ? ' theme-radius-posters-top' : stripeAppearance === 'no_slide' ? ' theme-radius-posters-top' :' theme-radius-posters-full'
    const bluePricesClass = getBluePrices(technologyAttributes)
    const {posterAttributeTop ,posterAttributeBottom, hasPosterAttributeClass, hasPosterAttributeBottomClass} = getPosterAttributeSettings(posterAttribute)
    const stripeAppearanceNoSlide = stripeAppearance === 'no_slide' ? true : false

    const getBackgroundImage = () => {
        if(backgroundsObj.ambient) {
            let sizeQuery = ''

            if(backgroundsObj.ambient.url.search("orchestrationlayer.cloudticket.net") !== -1 || backgroundsObj.ambient.url.search("cineorder-content-uat.cloudticket.net") !== -1 ) {
                sizeQuery = "&size=400"
            }
            const styles = getBackgroundStyles(backgroundsObj.ambient, true, isMobile)

            return (
                <div className="image" style={styles}>
                    <span className='screen-reader-text'>{title + " " + getTranslation('moviePoster', translation)}</span>
                </div>
            )

        } else {
            return (
                <div className="no-image-container">
                    <div className="no-image">{title}</div>
                </div>
            )
        }
    }

    return (
        <div className={'poster-format-item-wrapper background-version'}>    
            <div className={"poster-format-item" + bluePricesClass + ' ' + posterStyling} style={style} onMouseOver={() => {setMouseOver(true)}} onMouseOut={() => {setMouseOver(false)}}>       
                <BackgroundFormatItemLink pk={pk} translation={translation} moviesRoutesData={moviesRoutesData} goToMoviepage={goToMoviepage} className={"picture-wrapper cursor-pointer" + borderClass} onClick={() => onClickItem({id: itemID, movieTitle: title, index: index})} to={scrollToPosition + ' openMovieInformation'} smooth={true} offset={-200}>
                    {getBackgroundImage()}

                    {posterAttributeTop && !stripeAppearanceNoSlide && <div className="poster-attribute text-xlarge-bold poster-attribute-text theme-radius-posters-top top-attribute">
                            {posterAttribute.name}
                        </div>
                    }

                    {currentTitle && !stripeAppearanceNoSlide && !stripeAppearanceNoSlide && <div className={'text-xlarge-bold movie-title' + hasPosterAttributeClass + hasPosterAttributeBottomClass}>
                        {currentTitle}    
                    </div>}

                    {posterAttributeBottom && !stripeAppearanceNoSlide && <div className="poster-attribute text-xlarge-bold poster-attribute-text bottom-attribute">
                            {posterAttribute.name}
                        </div>
                    }

                    {posterStyling === "hoveranimation" && <div className='poster-info'>
                        <FskWrapper fsk={fsk}/>
                        <div className='tickets-button'><div className='tickets-icon'></div><p className=''><Translation id="tickets" trans={translation}></Translation></p></div>                                
                        <div className='attributes-container'>
                            {!noAttributesToDisplayWithSchnäppchen && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                            {!noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithIcons} canBeColored={true} />
                            </div>}
                            {!noAttributesWithoutIconsToDisplay && <div className='attributes-without-icons'>
                                <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithoutIcons} />
                            </div>}
                        </div>
                    </div>}

                    {posterStyling === "fsk_on_poster" && (fsk === 16 || fsk === 18) && <div className={"poster-info fsk-hint-poster theme-radius-posters-full"}>
                        <FskWrapper fsk={fsk}/>
                    </div>}

                    {(posterAttributeTop || posterAttributeBottom)&& stripeAppearanceNoSlide && <div className="poster-attribute-no-slide text-xlarge-bold poster-attribute-text">
                            {posterAttribute.name}
                        </div>
                    }
                    
                    {stripeAppearanceNoSlide && !noAttributesWithoutIconsToDisplay && <div className='attributes-without-icons'>
                        <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithoutIcons} />
                    </div>}
                </BackgroundFormatItemLink>

                {!hideInfo && <div className='movie-info-wrapper theme-radius-posters-bottom'>
                    {currentTitle && stripeAppearanceNoSlide && <div className={'text-xlarge-bold movie-title-no_slide'}>
                        {currentTitle}    
                    </div>}
                    <div className='horizontal-flex-wrapper'>
                        <div className='more-information-wrapper'>
                            {stripeAppearanceNoSlide && !isMobile && <div className='more-information row-flex-information'>
                                {length && <Length length={length} translation={translation}/>}
                                <FskWrapper fsk={fsk}/>
                                {!noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                    <ItemAttributesContainer performanceAttribute={false} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                </div>}
                            </div>}
                            {showPerformances && <ItemPerformancesContainer
                                movieId={itemID}
                                itemData={itemData}
                                scrollToPosition={scrollToPosition} 
                                dayFilters={dayFilters}
                                movieIndex={index}
                                filterValue={filterValue}
                                filterType={filterType}
                                queryStringValues={queryStringValues}
                                overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                                performances={performances} 
                                stripeAppearance={stripeAppearance}
                                isMobile={isMobile}
                                onClick={() => onClickItem({id: itemID, movieTitle: title, index: index})} 
                                onOpenPerformancePage={onOpenPerformancePage}
                            />}
                        </div>
                        {multitotalStyle === 'default' && themeColors === 'Arthouse' && relevantCinemas.length !== 0 && 
                            <div className='cinemas-icon-wrapper'>
                                {relevantCinemas.map((cinemaPk, index) => {
                                    return <CinemaIcon cinemaData={cinemas[cinemaPk]} key={index} />
                                })}
                            </div>
                        }
                    </div>
                </div>}

            </div>
        </div>
    )
}

export default BackgroundFormatItem